module.exports = __webpack_public_path__ + "static/media/drive_car.e72eba2e.jpg";